let userLogin = false;
let userLoginDetails = '';

const windowGlobal = typeof window !== 'undefined' && window;

if(windowGlobal){
    let userD = localStorage.getItem('userDetails');
    let userData = JSON.parse(userD);
    if (userData && userData.hasOwnProperty('uid')) {
        userLogin = true;
        userLoginDetails = userData;
    }
}

const initialState = {
    isUserLogin: userLogin,
    loginUserDetails: userLoginDetails || {},

    buttonDisabled: false,
    errorMessage: '',

    juniorToken: '',
    juniorGenerateToken: false,
    juniorFormSubmit: false,
    juniorStripeError: '',
    juniorEmailError: '',
    juniorCheckboxError: '',

    seniorToken: '',
    seniorGenerateToken: false,
    seniorFormSubmit: false,
    seniorStripeError: '',
    seniorEmailError: '',
    seniorPhoneError: '',
    seniorCheckboxError: '',



    backToken:'',
    backGenerateToken:false,
    backFormSubmit: false,
    backStripeError:'',
    backtoPhoneNumber:'',
    plan:'junior',
    backEmail: '',

    registerPlan: 'junior',
    registerEmail: '',
    registerPhoneNumber: '',
    registerNameOnCard: '',
    registerTermCondition: false,
    registerToken: '',
    registerGenerateToken: false,
    registerEmailError: '',
    registerPhoneError: '',
    registerCheckboxError: '',
    registerKlarnaToken: '',
    registerCampaign: 'common',
    registerPassword: '',
    registerPasswordError: '',
    activePopup: false,

    registerNameCardError: '',

    mobileMenuActive: false,
    headerMobileActive: false,

    showKlarnaButton: false,

    junibackenParticipate : [{name: '', dob: '', nameError: '', dobError: ''}],
    junibackenTotalParticipate : 1,
}

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'IS_USER_LOGIN':
                return {
                    ...state,
                    isUserLogin: action.value
                }
            break;
        case 'LOGIN_USER_DETAILS':
                return {
                    ...state,
                    loginUserDetails: action.value
                }
            break;
        case 'DISABLED_BUTTON':
            return {
                ...state,
                buttonDisabled: action.value
            }
            break;
        case 'ERROR_MESSAGE':
            return {
                ...state,
                errorMessage: action.value
            }
            break;
        case 'JUNIOR_TOKEN':
            return {
                ...state,
                juniorToken: action.value
            }
            break;
        case 'BACKTO_PLAN':
                return {
                    ...state,
                    plan: action.value
                }    
            break;
        case 'JUNIOR_GENERATE_TOKEN':
            return {
                ...state,
                juniorGenerateToken: action.value
            }
            break;
        case 'JUNIOR_FORM_SUBMIT':
            return {
                ...state,
                juniorFormSubmit: action.value
            }
            break;
        case 'JUNIOR_STRIPE_ERROR':
            return {
                ...state,
                juniorStripeError: action.value
            }
            break;
        case 'JUNIOR_EMAIL_ERROR':
            return {
                ...state,
                juniorEmailError: action.value
            }
            break;
        case 'JUNIOR_CHECKBOX_ERROR':
            return {
                ...state,
                juniorCheckboxError: action.value
            }
            break;
        case 'SENIOR_TOKEN':
                return {
                    ...state,
                    seniorToken: action.value
                }
                break;
        case 'SENIOR_GENERATE_TOKEN':
            return {
                ...state,
                seniorGenerateToken: action.value
            }
            break;
        case 'SENIOR_FORM_SUBMIT':
            return {
                ...state,
                seniorFormSubmit: action.value
            }
            break;
        case 'SENIOR_STRIPE_ERROR':
            return {
                ...state,
                seniorStripeError: action.value
            }
            break;
        case 'SENIOR_EMAIL_ERROR':
            return {
                ...state,
                seniorEmailError: action.value
            }
            break;
        case 'SENIOR_PHONE_ERROR':
            return {
                ...state,
                seniorPhoneError: action.value
            }
            break;
        case 'SENIOR_CHECKBOX_ERROR':
            return {
                ...state,
                seniorCheckboxError: action.value
            }
            break;
        case 'BACKTO_TOKEN':
            return {
                ...state,
                backToken: action.value
            }
            break;    
        case 'BACKTO_GENERATE_TOKEN':
                return {
                    ...state,
                    backGenerateToken: action.value
                }
                break;    
        case 'BACKTO_FORM_SUBMIT':
                return {
                    ...state,
                    backFormSubmit: action.value
                }
                break;    
        case 'BACKTO_STRIPE_ERROR':
                return {
                    ...state,
                    backStripeError: action.value
                }
                break;    
        case 'REGISTER_PLAN':
            return {
                ...state,
                registerPlan: action.value
            }
            break;
        case 'REGISTER_EMAIL':
            return {
                ...state,
                registerEmail: action.value
            }
            break;
         case 'BACKTO_EMAIL':
                return {
                    ...state,
                    backEmail: action.value
                }
                break;    
        case 'BACKTO_PHONE_NUMBER':
                    return {
                        ...state,
                        backtoPhoneNumber: action.value
                    }
                    break;       
        case 'REGISTER_PHONE_NUMBER':
            return {
                ...state,
                registerPhoneNumber: action.value
            }
            break;
        case 'REGISTER_NAME_ON_CARD':
            return {
                ...state,
                registerNameOnCard: action.value
            }
        case 'REGISTER_TERM_CONDITION':
            return {
                ...state,
                registerTermCondition: action.value
            }
            break;
        case 'REGISTER_TOKEN':
            return {
                ...state,
                registerToken: action.value
            }
            break;
        case 'REGISTER_GENERATE_TOKEN':
            return {
                ...state,
                registerGenerateToken: action.value
            }
            break;
        case 'REGISTER_EMAIL_ERROR':
            return {
                ...state,
                registerEmailError: action.value
            }
            break;
        case 'REGISTER_PHONE_ERROR':
            return {
                ...state,
                registerPhoneError: action.value
            }
            break;
        case 'REGISTER_CHECKBOX_ERROR':
            return {
                ...state,
                registerCheckboxError: action.value
            }
            break;
        case 'REGISTER_NAMECARD_ERROR':
            return {
                ...state,
                registerNameCardError: action.value
            }
            break;
            
        case 'REGISTER_KLARNA_TOKEN':
            return {
                ...state,
                registerKlarnaToken: action.value
            }
            break;
        
        case 'REGISTER_CAMPAIGN':
            return {
                ...state,
                registerCampaign: action.value
            }
            break;
        
        case 'REGISTER_PASSWORD': 
            return {
                ...state,
                registerPassword: action.value
            }
            break;
        
        case 'REGISTER_PASSWORD_ERROR': 
            return {
                ...state,
                registerPasswordError: action.value
            }
            break;

        case 'ACTIVE_POPUP':
            return {
                ...state,
                activePopup: action.value
            }
            break;            
            
        case 'MOBILE_MENU':
            return {
                ...state,
                mobileMenuActive: action.value
            }
            break;
        case 'HEADER_MOBILE_MENU':
            return {
                ...state,
                headerMobileActive: action.value
            }
            break;
        
        case 'SHOW_KLARNA_BUTTON':
            return {
                ...state,
                showKlarnaButton: action.value
            }
            break;
        case 'JUNIBACKEN_PARTICIPATE':
            return {
                ...state,
                junibackenParticipate: [...state.junibackenParticipate, {name: '', dob: '', nameError: '', dobError: ''}],
                junibackenTotalParticipate: [...state.junibackenParticipate].length + 1
            }
            break;
            
        case 'PARTICIPATE_FIELD':
            let obj = [...state.junibackenParticipate];
            obj[action.value.key][action.value.name] = action.value.value;
            return {
                ...state,
                junibackenParticipate: obj
            }
        break;
        case 'PARTICIPATE_TOTAL':
            return {
                ...state,
                junibackenTotalParticipate: action.value
            }
        break;
            
            
        default:
            break;
    }
    return state;
}
